import { StorageService } from './../../services/storage.service';
import { Injectable } from '@angular/core';
import { Router, Route, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Location } from "@angular/common";
import { NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class AuthGuardService  {

  constructor(private router: Router,
    private storageService: StorageService,
    private jwthelper: JwtHelperService,
  ) { }

  canLoad(route: Route): Observable<boolean> | boolean {
    const disposableEmail = this.storageService.getData('disposable_email');
    const token = this.storageService.getData('access_token');

    // If disposable email exists
    if (token && disposableEmail) {
      this.storageService.removeData('access_token');
      this.router.navigate(['/']);
      return false; // Stop navigation to the original route
    } else {

      if (this.storageService.getData('access_token')) {
        const token = this.storageService.getData('access_token');
        const allowedRole = route.data.allowedRole;
        const payLoad = this.jwthelper.decodeToken(token);
        if (payLoad.role === allowedRole) {
          return true;
        }
        this.router.navigate([`${payLoad.role}`]);
      } else {
        const existLocation = window.location.pathname;
        this.router.navigate(['login/'], { queryParams: { returnUrl: existLocation}});
        return false;
      }
    }
  }

}
